// extracted by mini-css-extract-plugin
module.exports = {"container":"RetailerSearch_container__2iY5u","locationIcon":"RetailerSearch_locationIcon__r162t","searchStore":"RetailerSearch_searchStore__32b83"};